import {
  Col,
  Form,
  InputNumber,
  Modal,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import BackButton from "../../helpers/BackButton";
import PageWrapper from "../../helpers/PageWrapper";
import useAssessmentsPage from "./useAssessmentsPage";
import FinalAssessmentModal from "../FinalAssessmentModal";
import { Button, message } from "antd";
import { TableOutlined } from "@ant-design/icons";
import React, { useContext, useEffect, useRef, useState } from 'react';
import ExamAssessmentModal from "../ExamAssessmentModal";
import FinalExamAssessmentModal from "../FinalExamAssessmentModal";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
        >
          <InputNumber min={0} max={100} />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const AssessmentsPage = () => {
  const {
    filteredStudentsData,
    exportAssesmentsList,
    mergedColumns,
    isModalOpen,
    currentFinalAssessmentStudent,
    setCurrentFinalAssessmentStudent,
    openFinalAssessmentModal,
    openExamAssessmentModal,
    openFinalExamAssessmentModal,
    handleChangeFinalAssessment,
    handleCancel,
    isExamAssessmentModalOpen,
    isFinalAssessmentModalOpen,
    isFinalExamAssessmentModalOpen,
    closeFinalAssessmentModal,
    closeExamAssessmentModal,
    closeFinalExamAssessmentModal,
    finalAssessmentData,
    examAssessmentData,
    finalExamAssessmentData,
    loading,
    form,
  } = useAssessmentsPage();
  

  return (
    <PageWrapper>
      <BackButton link="/" />
      <Typography.Title level={1}>Журнал</Typography.Title>
      <Row>
        <Col flex="auto"></Col>
        <Col flex={0}>
          <Space style={{ marginBottom: 20 }}>
            <Button
              type="primary"
              variant="warning"
              onClick={exportAssesmentsList}
              icon={<TableOutlined />}
            >
              Экспортировать журнал
            </Button>
            <Button onClick={openFinalAssessmentModal}>
              Список оценок за семестр
            </Button>
            <Button onClick={openExamAssessmentModal}>
              Список оценок за экзамен
            </Button>
            <Button onClick={openFinalExamAssessmentModal}>
              Список итоговых оценок 
            </Button>
          </Space>
        </Col>
      </Row>
      
      <Form form={form} component={false}>
        <Table
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          bordered
          dataSource={filteredStudentsData}
          columns={mergedColumns}
          loading={loading}
          rowClassName="editable-row"
          scroll={{ x: "auto" }}
          pagination={{ position: ["topLeft"] }}
        />
      </Form>
      <Modal
        title="Итоговая оценка"
        visible={isModalOpen}
        okText={"Изменить оценку"}
        onOk={handleChangeFinalAssessment}
        onCancel={handleCancel}
      >
        <Typography.Title level={4}>
          {currentFinalAssessmentStudent?.studentName ?? (
            <Typography.Text type="secondary">Кто же это...</Typography.Text>
          )}
        </Typography.Title>
        <Typography.Title level={5} type="secondary">
          Итоговая оценка:
        </Typography.Title>
        <InputNumber
          min={0}
          max={100}
          value={currentFinalAssessmentStudent?.currentGrade}
          onChange={(value) =>
            setCurrentFinalAssessmentStudent((prevValues) => ({
              ...prevValues,
              assessment: value,
            }))
          }
          style={{ margin: 0 }}
        />
      </Modal>
      <FinalAssessmentModal
        isModalOpen={isFinalAssessmentModalOpen}
        onCancel={closeFinalAssessmentModal}
        data={finalAssessmentData}
        loading={loading}
      />
      <ExamAssessmentModal
        isModalOpen={isExamAssessmentModalOpen}
        onCancel={closeExamAssessmentModal}
        data={examAssessmentData}
        loading={loading}
      />
      <FinalExamAssessmentModal
        isModalOpen={isFinalExamAssessmentModalOpen}
        onCancel={closeFinalExamAssessmentModal}
        data={finalExamAssessmentData}
        loading={loading}
      />
      
        
      
    </PageWrapper>
  );
};

export default AssessmentsPage;
